import backendURL from "./config";

export const addCategoryAPI = async (category) => {
  try {
    const response = await backendURL.post("category/register", { category });
    return response.data.data;
  } catch (error) {
    console.error("Error adding to gallery:", error);
    throw error;
  }
};
export const editCategoryAPI = async (id, category) => {
  try {
    const response = await backendURL.post("category/update", {
      id,
      category,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error adding to gallery:", error);
    throw error;
  }
};

export const deleteCategoryAPI = async (id) => {
  try {
    const response = await backendURL.post("category/delete", {
      id,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding to gallery:", error);
    throw error;
  }
};
export const viewCategory = async (page, pageSize) => {
  try {
    const response = await backendURL.post("/category/view", {
      page,
      pageSize,
    });
    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Error Response:", error.response.data);
      throw new Error(
        error.response.data.message || "Failed to fetch categories"
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("Something went wrong. Please try again.");
    }
  }
};

export const viewCategorysApi = async () => {
  try {
    const response = await backendURL.get("category/viewCategory");
    return response.data.data;
  } catch (error) {
    if (error.response) {
      console.error("Error Response:", error.response.data);
      throw new Error(
        error.response.data.message || "Failed to fetch categories"
      );
    } else {
      console.error("Unexpected Error:", error);
      throw new Error("Something went wrong. Please try again.");
    }
  }
};
